import script from "./ServiceRequirementsListComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceRequirementsListComponent.vue?vue&type=script&setup=true&lang=js"

import "./ServiceRequirementsListComponent.vue?vue&type=style&index=0&id=39c09548&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39c09548"]])

export default __exports__